// Schedule window: blocked time period (curfew)
export interface ScheduleWindow {
  id: string;
  daysMask: number; // bitwise: bit 0=Sunday, bit 1=Monday, etc.
  startMinute: number; // 0-1439 (minutes since midnight)
  endMinute: number; // 0-1439
}

// Day-of-week limit override: replaces daily limit for specific day
export interface DayLimitOverride {
  id: string;
  dayOfWeek: number; // 0=Sunday, 6=Saturday
  limitMinutes: number;
}

export interface ScheduleEditorState {
  daysMask: number;
  startTime: string; // HH:MM format
  endTime: string; // HH:MM format
}

export interface DayOverrideEditorState {
  dayOfWeek: number;
  limitMinutes: number;
}

// Helper: day names
export const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const DAY_SHORT_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Helper: convert time string (HH:MM) to minutes since midnight
export function timeToMinutes(timeStr: string): number {
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
}

// Helper: convert minutes since midnight to time string (HH:MM)
export function minutesToTime(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
}

// Helper: format schedule for display
export function formatScheduleWindow(window: ScheduleWindow): string {
  const days: string[] = [];
  for (let i = 0; i < 7; i++) {
    if (window.daysMask & (1 << i)) {
      days.push(DAY_SHORT_NAMES[i]);
    }
  }
  const start = minutesToTime(window.startMinute);
  const end = minutesToTime(window.endMinute);
  return `${days.join(', ')} ${start}–${end}`;
}
